import {Header, Layout} from '@components/common'
import { Container } from '@components/ui'
import {fetchJson, getShopNavigation} from "../index";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Image from "next/image";
import {getStrapiMedia} from "@utils/strapi";
import delve from "dlv";
import {useTranslation} from "next-i18next";

export async function getServerSideProps(context: any) {
  const {locale, params} = context;
  const url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}`;
  const sponsorGallery = await fetchJson(url + '/api/sponsor-gallery?populate[0]=Sponsors.Url&populate[1]=Sponsors.Name&populate[2]=Sponsors.Logo', 'data.attributes.Sponsors');
  let mainSponsors: any[] = [];
  let titleSponsors: any[] = [];
  let partners: any[] = [];
  let suppliers: any[] = [];
  if (sponsorGallery && sponsorGallery.length > 0) {
    sponsorGallery.forEach((sponsor: any) => {
      if (sponsor.isU19) {
        return;
      }
      if (sponsor.isMainSponsor) {
        mainSponsors.push(sponsor);
      }
      if (sponsor.isTitleSponsor) {
        titleSponsors.push(sponsor);
      }
      if (sponsor.isPartner) {
        partners.push(sponsor);
      }
      if (sponsor.isSupplier) {
        suppliers.push(sponsor);
      }
    });
  }
  return {
    props: {
      mainSponsors,
      titleSponsors,
      partners,
      suppliers,
      ...(await serverSideTranslations(locale, ["common", "home"])),
      ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
    }
  }
}

export default function Sponsors(data: any) {

  const mainSponsors = data.mainSponsors;
  const titleSponsors = data.titleSponsors;
  const partners = data.partners;
  const suppliers = data.suppliers;
  const { t } = useTranslation("common");
  return (
    <Container className="pt-4">
      <Header></Header>
      <div className="container-rg">
        {/*<div className="mb-8">
        <a data-flickr-embed="true" href="https://www.flickr.com/photos/boraargon18/albums/72177720306034667"
           title="Volta ao Algarve 2023">
          <img src="https://live.staticflickr.com/65535/52691094979_9597ff5d13_h.jpg"
                                              width="1600" height="1600" alt="Volta ao Algarve 2023"/>
        </a>
        </div>*/}
        <section className="text-center mb-8">
          <h4 className="uppercase mb-4">{t("main-sponsor")}</h4>
          <div className="sponsor-grid bg-black">
            <div className="md:w-1/3">
              {
                mainSponsors ?
                  mainSponsors.map((sponsor: any, index: number) => {
                   return (
                     <a key={index + '_main_sponsors'} href={sponsor.Url}>
                       <Image
                         key={index}
                         className="object-contain"
                         src={getStrapiMedia(delve(sponsor.Logo, 'data.attributes.url')) || ""}
                         alt={delve(sponsor.Logo, 'data.attributes.alternativeText') || ""}
                         width={400}
                         height={400}
                         priority={false}
                         quality="85"
                       />
                     </a>
                   )
                  }) : null
              }
            </div>
          </div>
        </section>
        <section className="text-center mb-8">
          <h4 className="uppercase mb-4 text-[#333]">{t("title-sponsor")}</h4>
          <div className="sponsor-grid bg-[#333333]">
            <div className="md:w-1/3">
              {
                titleSponsors ?
                  titleSponsors.map((sponsor: any, index: number) => {
                    return (
                      <a key={index + '_title_sponsors'} href={sponsor.Url}>
                        <Image
                          key={index}
                          className="object-contain"
                          src={getStrapiMedia(delve(sponsor.Logo, 'data.attributes.url')) || ""}
                          alt={delve(sponsor.Logo, 'data.attributes.alternativeText') || ""}
                          width={400}
                          height={400}
                          priority={false}
                          quality="85"
                        />
                      </a>
                    )
                  }) : null
              }
            </div>
          </div>
        </section>

        <section className="text-center mb-8">
          <h4 className="uppercase mb-4 text-accent-3">{t("partner")}</h4>
          <div className="sponsor-grid bg-accent-3">
            {
              partners ?
                partners.map((sponsor: any, index: number) => {
                  return (
                    <div key={index}>
                      <a key={index} href={sponsor.Url}>
                        <Image
                          className="object-contain"
                          src={getStrapiMedia(delve(sponsor.Logo, 'data.attributes.url')) || ""}
                          alt={delve(sponsor.Logo, 'data.attributes.alternativeText') || ""}
                          width={400}
                          height={400}
                          priority={false}
                          quality="85"
                        />
                      </a>
                    </div>
                  )
                }) : null
            }
          </div>
        </section>

        <section className="text-center mb-8">
          <h4 className="uppercase mb-4 text-accent-4">{t("suppliers")}</h4>
          <div className="sponsor-grid bg-accent-4">
            {
              suppliers ?
                suppliers.map((sponsor: any, index: number) => {
                  return (
                    <div key={index + '_suppliers'}>
                      <a href={sponsor.Url}>
                        <Image
                          className="object-contain mx-4"
                          src={getStrapiMedia(delve(sponsor.Logo, 'data.attributes.url')) || ""}
                          alt={delve(sponsor.Logo, 'data.attributes.alternativeText') || ""}
                          width={400}
                          height={400}
                          priority={false}
                          quality="85"
                        />
                      </a>
                    </div>
                  )
                }) : null
            }
          </div>
        </section>

      </div>
    </Container>
  )
}

Sponsors.Layout = Layout
